import { api, apiRequest } from "./api";
import type { Tracker, TrackerSearchParams } from "@/types";

export const trackersAPI = {
  list: (params?: TrackerSearchParams) =>
    apiRequest<Tracker[]>(() => api.get("/vitals/trackers/", { params })),
};
